import { useSelector } from "react-redux";

import SiteTitle from "./../../../helpers/SiteTitle/SiteTitle";
import Menu from "./../../../helpers/Menu";
import { base_url } from "../../../services/configServices/config";

const MenuPublic = () => {
  const image = useSelector((state) => state.meta?.image);
  const setting = useSelector((state) => state.meta?.setting);

  return (
    <>
      <SiteTitle title="منو" />

      {/* Section Started Inner */}
      <section className="section kf-started-inner">
        <div
          className="kf-parallax-bg"
          style={{ backgroundImage: `url(${base_url + image?.menuBanner})` }}
        />
        <div className="container">
          <h1
            className="kf-h-title text-anim-1 scroll-animate align-center"
            data-animate="active"
          >
            منو {setting?.title}
          </h1>
        </div>
      </section>
      {/* Section Menu */}
      <Menu />
    </>
  );
};

export default MenuPublic;
